import { Suspense } from 'react';
import { queryClient } from './shared/libs/react-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';
import { ClaimScoreLoader, ThemeProvider, ToastProvider } from 'ui';
import { useAppRoutes } from '@hooks/customHooks/useAppRoutes';
import { useMessengerInit } from '@hooks/customHooks/useMessengerInit';
import { AuthProvider } from './context/AuthContext';

export function App() {
  const { router } = useAppRoutes();
  useMessengerInit();

  return (
    <ThemeProvider>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <Suspense fallback={<ClaimScoreLoader />}>
              <RouterProvider router={router} />
            </Suspense>
          </AuthProvider>
          {import.meta.env.VITE_APP_ENV === 'dev' && (
            <ReactQueryDevtools initialIsOpen={false} />
          )}
        </QueryClientProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
